<script setup>
import Button from '@/Components/Button.vue';
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    resolution: Array,
})
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 py-5 md:py-10">
        <template v-for="item in resolution">
            <div class="flex justify-center md:justify-start items-center order-2 md:order-1">
                <img class="size-banner-hero-section" :src="getImage(item.image_article)" alt="banners about us">
            </div>

            <div class="flex flex-col h-full justify-center items-center md:items-start gap-y-2 md:gap-y-3 order-1 md:order-2">
                <h1 class="text-title-content text-center md:text-start">{{ item.title }}</h1>
                <p class="text-description text-grayBlackColor text-center md:text-start" v-html="item.description"></p>

                <div class="w-full grid justify-center md:justify-start items-center md:items-start mt-5">
                    <Button class="block" :btnName="'អានបន្ថែមអំពីពួកយើង'" :routeName="'about.us'"/>
                </div>
            </div>
        </template>
    </div>
</template>
